<template>
  <div id="introduction">
    <h3>Introduction</h3>
    <p>
      Hi! I'm happy that you're looking for a Vue Bootstrap sidebar package and
      found mine. I did the same but unfortunately I couldn't find a package
      that would have fit my needs. I really hope that you'll find what you were
      looking for. If you think something is missing or you could improve the
      package, please <router-link to="/contribute"> contribute </router-link>
      to the project and make a pull request so that the next person can have an
      easier time.
    </p>
    <p>
      I'm also looking for some reviews and input, so in case you were somebody
      experienced with Vue and npm packages and you could spend a few minutes
      reviewing my package I'd really grateful!
    </p>
  </div>
</template>

<script>
export default {
  name: 'Introduction'
};
</script>

<style></style>
